// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"FormFieldLabel-module__infoIcon--17Gt-"};